<template>
  <div class="wrapper">
    <div class="panel">
      <div class="body-panel-login">
        <img
          class="img-fluid mx-auto d-block"
          src="@/assets/logo-indecx.png"
          alt=""
        />
        <div class="message text-center">
          <p>{{ $t('message.sendCodeAuth') }}</p>
          <h4>{{ user.phone }}</h4>
        </div>
        <b-form-group>
          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
            <b-input-group-text slot="prepend">
              <font-awesome-icon :icon="['fas', 'key']" />
            </b-input-group-text>
            <b-input
              id="key"
              v-model="form.keyAuth"
              type="text"
              required
              :placeholder="`${this.$t('authentication.accessCode')}`"
              @keyup.enter="sendAuth"
              autofocus
            ></b-input>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-button
            type="submit"
            class="btn-block"
            variant="primary"
            @click="sendAuth"
          >
            {{ $t('authentication.validate') }}
          </b-button>
          <b-button
            @click="loginByEmail(user.email)"
            type="submit"
            class="btn-block"
            variant="outline-primary"
          >
            {{ $t('authentication.noAccess') }}
          </b-button>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Autenticação',
  data: () => ({
    show: true,
    form: {
      keyAuth: null,
    },
  }),
  computed: {
    ...mapState('authentication', ['user']),
  },
  methods: {
    ...mapActions('authentication', ['authentication', 'loginByEmail']),
    sendAuth() {
      this.authentication({
        pinAuth: this.form.keyAuth,
        email: this.user.email,
      });
    },
  },
  created() {
    if (!this.user.email) {
      this.$router.push('/');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.wrapper {
  @extend %center;
  @include bg-color($secondary);
  .panel {
    width: 90%;
    max-width: 400px;

    border-radius: 5px;
    display: flex;
    flex-direction: column;

    @include bg-color($white);
    @media screen and (min-width: 576px) {
      width: 100%;
    }
    .body-panel-login {
      // @include bg-color($white);
      @extend %default-padding-left,
        %default-padding-right,
        %double-padding-top,
        %double-padding-bottom;

      .img-fluid {
        width: 50%;
        margin-bottom: 30px;
      }
      .message {
        margin-bottom: 30px;
        color: $secondary;
        h4 {
          font-weight: bold;
        }
      }
      .input-group-text {
        border: none;
        @include bg-color($gray-lighter);
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        color: $secondary;
      }
      .form-control {
        box-shadow: none;
        border: none;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        @include bg-color($gray-lighter);
        text-indent: 0;
        padding: 0;
        color: $secondary;
      }
      button {
        border-radius: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/authentication/index.vue